module.exports = __webpack_public_path__ + "img/esp.91e37699.svg";